module.exports = "/_next/static/images/housesitter.com-7076f24d2567e49bb4a3cd543d1952eb.svg";